import "./login.scss";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext.jsx"; // Ensure this path is correct
import apiRequest from "../../../lib/apiRequest.js"; // Ensure this path is correct
import bg from "../../../assets/bg.png";
import { isLocalhost } from "../../../../checkLocalhost.jsx";

import facebook from "../../../assets/facebook.png";
import google from "../../../assets/google.png";
import insta from "../../../assets/insta.png";
import logouticon from "../../../assets/logout.png";
import LinkWithCallback from "../../../components/linknav/LinkWithCallback.jsx";
// import Toast from "../../components/showtoast/Toast.jsx"
// import { useToast } from "../../components/showtoast/ToastContext.jsx";
import { useApiError } from "../../../lib/errorHandler.jsx";



function Login() {
  const { login, SocialLogin } = useContext(AuthContext);
  const [credentials, setCredentials] = useState({ useremail: "", password: "" });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleApiError = useApiError();



//  const { showToast } = useToast();


  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  // const handleLogout = () => {
  //   fetch("/8800/api/auth/logout", { // Ensure this path is correct
  //     method: "POST",
  //     credentials: "include",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Accept": "application/json"
  //     }
  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         navigate("/");
  //       } else {
  //         console.error("Logout failed:", response.statusText);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Logout failed:", err);
  //     });
  // };




  const handleLogout = async () => {
    try {
      const response = await apiRequest.post("/auth/logout", {}, {
        withCredentials: true,
        headers: {
          "Accept": "application/json",
        }
      });
  
      if (response && response.status === 200) {
        navigate("/");
      } else {
        console.error("Logout failed:", response.statusText);
      }
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };
  

  const generatePassword = () => {
    const length = 8; // Password length
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const specialChars = '!@#$%^&*()_+[]{}|;:,.<>?';
  
    let password = '';
  
    // Ensure at least 1 uppercase letter, 1 special character, and 2 digits are included
    password += uppercase[Math.floor(Math.random() * uppercase.length)];  // 1 uppercase
    password += specialChars[Math.floor(Math.random() * specialChars.length)];  // 1 special character
    password += digits[Math.floor(Math.random() * digits.length)];  // 1 numeric digit
    password += digits[Math.floor(Math.random() * digits.length)];  // 2nd numeric digit
  
    // Add 4 more random lowercase characters (to make up the 8 total characters)
    for (let i = password.length; i < length - 2; i++) {
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
    }
  
    // Shuffle the password to mix the order of characters
    password = password.split('').sort(() => Math.random() - 0.5).join('');
  
    return password;
  };


  const handleGoogle = () => {
    //http://localhost:8000/api/passport/google
    //VITE_DSERVER_BASEURL=http://localhost:8000
    //VITE_API=/api



    // console.log("in login page")
    // const dserverBaseUrl = import.meta.env.VITE_IS_LOCALHOST=='true'
    const dserverBaseUrl = isLocalhost

    ? import.meta.env.VITE_DSERVER_BASEURL   // e.g. http://localhost:8000
    : import.meta.env.VITE_SH_DSERVER_BASEURL; // e.g. https://www.fulcrumengineers.in/bhoomi
                      
    const clientURL=window.location.origin
    // const authURL = `${dserverBaseUrl}${import.meta.env.VITE_SH_API}/passport/google?client_url=${encodeURIComponent(clientURL)}`;
    const authURL = `${dserverBaseUrl}${import.meta.env.VITE_SH_API}/passport/google?client_url=${encodeURIComponent(clientURL)}`;

    // console.log("Client Url: ",clientURL)
    // console.log("dserverBaseURL: ",dserverBaseUrl)
    // console.log("authURL: ",authURL)

    // console.log("first request to your local server ",authURL);


    const authWindow = window.open(authURL, "_blank", "width=500,height=600");

    const handleMessage = async (event) => {

          // const expectedOrigin = import.meta.env.VITE_IS_LOCALHOST=='true'
          const expectedOrigin = isLocalhost
            ? import.meta.env.VITE_DSERVER_BASEURL
            : import.meta.env.VITE_SH_DSERVER_BASEURL;

            const allowedOrigins = [
              'http://localhost:5173',       // Local dev
              'http://127.0.0.1:5173',       // Alternate localhost
              'http://localhost:8000',
              'https://www.fulcrumengineers.in', // Production
              'https://fulcrumengineers.in',      // Production without www
              'https://www.bhoomi-india.com', // Production
              'https://bhoomi-india.com'      // Production without www
              
            ];



            // console.log("🔗 Listening for messages from:", expectedOrigin)
            // console.log("📬 Received message:", event.data);
            if (!allowedOrigins.includes(event.origin)) {
              
              // console.log("Event Origin",event.origin ," Expected Origin: ",expectedOrigin)
              console.warn("Unknown origin:", event.origin);
              console.warn("❌ Unknown origin:", event.origin);
              return;
            }      
            // if (event.origin !== expectedOrigin) {
            //   console.log("Event Origin",event.origin ," Expected Origin: ",expectedOrigin)
            //   console.warn("Unknown origin:", event.origin);
            //   return;
            // }

      if (event.data && event.data.user) {
        const SocialUser = {
          email: event.data.user.email,
          displayName: event.data.user.displayName,
          photo: event.data.user.photo,
        };

        // console.log("✅ Received user: now trying for social login", SocialUser);

        // try {
        //   await SocialLogin(SocialUser);
        //   navigate("/");
        // } catch (err) {
        //   console.error("❌ Social login failed:", err);
        // }


        (async () => {
          try {
            await SocialLogin(SocialUser);
            navigate("/");
          } catch (err) {
            console.error("❌ Social login failed:", err);
          }
        })();

        window.removeEventListener("message", handleMessage);
        if (authWindow && !authWindow.closed) authWindow.close();
      }
    };

    window.addEventListener("message", handleMessage);

    const cleanup = () => {
      window.removeEventListener("message", handleMessage);
      if (authWindow && !authWindow.closed) {
        // authWindow.close();
      }
    };

    window.addEventListener("beforeunload", cleanup);
    return cleanup;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      await login(credentials);
      navigate("/");
    } catch (error) {

      // console.log("error ",error)  
      const message = handleApiError(error); // <-- centralized error handling
      setError(message); // optionally show it inline


    } finally {
      setIsLoading(false);
    }
  };



// const handleGoogle = () => {
//   const dserverBaseUrl =
//     import.meta.env.VITE_IS_LOCALHOST === 'true'
//       ? import.meta.env.VITE_DSERVER_BASEURL   // http://localhost:8000
//       : import.meta.env.VITE_SH_DSERVER_BASEURL; // e.g., https://www.fulcrumengineers.in

//       const clientOrigin = window.location.origin;  // http://localhost:5173 or https://www.fulcrumengineers.in
//       const authURL = `${dserverBaseUrl}${import.meta.env.VITE_SH_API}/passport/google?origin=${encodeURIComponent(clientOrigin)}`;

//       const authWindow = window.open(authURL, "_blank", "width=500,height=600");

//   const handleMessage = async (event) => {
//     const allowedOrigins = [
//       'http://localhost:5173',       // Local dev
//       'http://127.0.0.1:5173',       // Alternate localhost
//       'http://localhost:8000',
//       'https://www.fulcrumengineers.in', // Production
//       'https://fulcrumengineers.in'      // Production without www
//     ];

//     if (!allowedOrigins.includes(event.origin)) {
//       console.warn("PostMessage failed. targetOrigin:", clientOrigin, "event.origin:", event.origin);

//       console.warn("PostMessage failed. event.origin not allowed:", event.origin);
//       return;
//     }





//     // if (event.origin !== clientOrigin) {

//     //   console.warn("Unknown origin:", event.origin);
//     //   return;
//     // }

//     if (event.data && event.data.user) {
//       const SocialUser = {
//         email: event.data.user.email,
//         displayName: event.data.user.displayName,
//         photo: event.data.user.photo,
//       };

//       try {
//         await SocialLogin(SocialUser);
//         navigate("/");
//       } catch (err) {
//         console.error("❌ Social login failed:", err);
//       }

//       window.removeEventListener("message", handleMessage);
//       if (authWindow && !authWindow.closed) authWindow.close();
//     }
//   };

//   window.addEventListener("message", handleMessage);

//   const cleanup = () => {
//     window.removeEventListener("message", handleMessage);
//     if (authWindow && !authWindow.closed) authWindow.close();
//   };

//   window.addEventListener("beforeunload", cleanup);
//   return cleanup;
// };



  return (
    <div className="login">
      <div className="wrapper">
        <div className="loginTitle PageHeader">
          <h1>Login</h1>
        </div>
        <div className="myRow">
          <div className="inputContainer">
            <div className="left">
              <div className="loginButton google" onClick={handleGoogle}>
                <img src={google} alt="" className="icon" />Google
              </div>
              <div className="loginButton facebook">
                <img src={facebook} alt="" className="icon" />Facebook
              </div>
              <div className="loginButton instagram">
                <img src={insta} alt="" className="icon" />Instagram
              </div>

              <div className="loginButton logout" onClick={handleLogout}>
                <img src={logouticon} alt="" className="icon" />logout
              </div>
            </div>
            <div className="right">
              <div className="formContainer">
                <form onSubmit={handleLogin}>
                  <input
                    type="text"
                    name="useremail"
                    value={credentials.useremail}
                    onChange={handleChange}
                    required
                    minLength={3}
                    maxLength={50}
                    placeholder="Email"
                  />
                  <input
                    type="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    required
                    placeholder="Password"
                  />
                  <button type="submit" disabled={isLoading}>Login</button>
                  {error && <span>{error}</span>}


                  <LinkWithCallback to={"/register"}>Register </LinkWithCallback>              
                  <LinkWithCallback to="/forgotpassword">Forgot Password</LinkWithCallback>


                </form>



                {/* Toast container */}
                {/* <div className="toast-container">
                  {toasts.map((t) => (
                    <Toast
                      key={t.id}
                      {...t}
                      onClose={() => removeToast(t.id)}
                    />
                  ))}
                </div> */}





              </div>
            </div>

          </div>

          <div className="imgContainer">
            <img src={bg} alt="" />
          </div>

        </div>
      </div>
    </div>
  );
}

export default Login;
